.root {
  & > * + * {
    margin-top: 20px;
  }
}
